import { ClientRepo } from "../client.repo";
import { PortfolioRepo } from "../../portfolio/portfolio.repo";
import { AuthService } from "../../common/auth.service";
import { TradingRepo } from "../../trading/trading.repo";
import { TradePortfolio } from "../../trading/models/tradePortfolio";
import { CModelRepo, Locality } from "../../cmodel/cmodel.repo";
import * as _ from "lodash";
import { TradeRestriction } from "../../trading/models/tradeRestriction";
import angular = require("angular");
import {
  AssetClassNameArray,
  AssetClassNames,
} from "../../common/enums/AssetClassType";
import { FeesRepo } from "../../fees/fees.repo";
import * as moment from "moment";
import { ClientDetails } from "../models/clientDetailsModel";
import { StrategyInformation } from "../models/strategyInformation";

class ClientDetailsController implements angular.IOnInit {
  public isLoading;
  public client: any;
  public searchText: string;
  public selectedPortfolio: any;
  public securities: Array<any>;
  public assetClasses: Array<any>;
  public crmLink: any;

  public title: string;

  public portfolioRiskProfiles: Array<any>;
  public portfolioTradeRestrictions: Array<TradePortfolio>;
  public selectedTradePortfolio: TradePortfolio;
  public clientFee: any;

  public feeForm: ng.IFormController;
  public feeTypes;
  public selectedFeeType: any;
  public userRoles: any;

  public linkedPortfolios: any;
  public potentialPortfoliosForFees: any;
  public clientPortfolioFees: any;
  public months: any[];

  public currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
  public languageList = ["English", "French 1", "French 2"];

  public benchmarkColumnNames = [
    "Benchmark (%)",
    "Benchmark IPS (%)",
    "Benchmark FM (%)",
    "Return Target (%)",
  ];

  public strategies = ["Combined", "Local", "International"];
  public selectedStrategies: Array<string> = [];
  public strategyInformation: StrategyInformation = {
    isLocalStrategyEnabled: false,
    isInternationalStrategyEnabled: false,
    isCombinedStrategyEnabled: false,
    localStrategy: "",
    internationalStrategy: "",
  };

  public showStrategyPanel: boolean = false;

  assetClassTypes = AssetClassNameArray;

  /** @ngInject */
  constructor(
    private clientRepo: ClientRepo,
    private portfolioRepo: PortfolioRepo,
    private tradingRepo: TradingRepo,
    private cModelRepo: CModelRepo,
    private $scope: angular.IScope,
    private $rootScope: angular.IRootScopeService,
    private $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private $mdDialog: angular.material.IDialogService,
    private notifyjs,
    private authService: AuthService,
    private feesRepo: FeesRepo
  ) {}

  $onInit() {
    this.months = moment.months().map((month, index) => {
      return {
        id: index+1,
        name: month
      }
    })
    let clientNumber = this.$stateParams["id"];
    this.clientRepo.getClient(clientNumber).then((val) => {
      this.client = val.data as ClientDetails;
      this.populatedSavedClientConfiguration();
      this.getClientPortfolioRiskProfile(this.client.id);
      this.getClientFees(this.client.clientNumber);
      this.getClientPortfolioRestrictions(this.client.id);
      this.getCrmLink();
    });

    this.getSecurities();
  }

  public getClientPortfolioRestrictions(clientId) {
    let that = this;
    that.isLoading = true;
    return that.tradingRepo
      .getClientPortfolioTradeRestrictions(clientId)
      .then((res) => {
        let tradingPortfolios = (res.data as any[])
          .map((tp) => new TradePortfolio(tp))
          .sort((a, b) => (a.name > b.name ? 1 : -1));

        tradingPortfolios.forEach((tp) =>
          tp.tradingRestrictions.sort((a, b) => {
            let aName = a.security ? "security" : "assetClass";
            let bName = b.security ? "security" : "assetClass";
            return a[aName].name > b[bName].name ? 1 : -1;
          })
        );
        that.portfolioTradeRestrictions = tradingPortfolios;
      })
      .catch((err) => this.notifyjs(err.data))
      .finally(() => (that.isLoading = false));
  }

  public getSecurities() {
    let that = this;
    if (that.securities != null) {
      return;
    }
    that.cModelRepo
      .getSecurityItemsList(null, null, false)
      .then((res) => {
        that.securities = res;
        that.securities.sort((a, b) => (a.name > b.name ? 1 : -1));
      })
      .catch((err) => {
        this.notifyjs(err.data);
      })
      .finally(() => (that.isLoading = false));
  }

  public getClientPortfolioRiskProfile = (clientId: number) => {
    this.portfolioRepo.getClientPortfolioRiskProfile(clientId).then((res) => {
      this.portfolioRiskProfiles = res.data as Array<any>;
      this.portfolioRiskProfiles.forEach((portfolioRiskProfile) => {
        portfolioRiskProfile.isEditing = false;
        this.addDefaultRiskProfile(portfolioRiskProfile);
      });
    });
  };

  public querySearch(searchText: string) {
    return this.portfolioRepo
      .filterPortfolios(searchText)
      .then((result) => result.data);
  }

  public linkPortfolio() {
    // add validation here
    this.client.portfolios.push(this.selectedPortfolio);
  }

  public newPortfolio() {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.client = this.client;
    tempScope.portfolio = {
      portfolioId: 0,
      name: "",
      isActive: true,
      isStrategic: false,
      accounts: [],
    };

    this.title = "New Portfolio";

    this.$mdDialog
      .show({
        template:
          '<md-dialog flex="30"><new-portfolio-modal client-number="client.clientNumber" portfolio="portfolio"></new-portfolio-modal></md-dialog>',
        scope: tempScope,
      })
      .then((result) => {
        if (result) {
          this.portfolioSaved(result);
        }
      });
  }

  private portfolioSaved(result: any) {
    if (result) {
      const index = this.client.portfolios.findIndex(
        (current) => current.portfolioId === result.portfolioId
      );
      if (index > -1) {
        this.client.portfolios[index] = result;
      } else {
        this.client.portfolios.push(result);
      }
    }
  }

  public editPortfolio(linkedPortfolioId: number) {
    this.portfolioRepo.getPortfolio(linkedPortfolioId).then((val) => {
      const tempScope = this.$rootScope.$new(true);
      tempScope["client"] = this.client;
      tempScope["portfolio"] = val.data;

      this.$mdDialog
        .show({
          template:
            '<md-dialog><new-portfolio-modal client-number="client.clientNumber" portfolio="portfolio"></new-portfolio-modal></md-dialog>',
          scope: tempScope,
        })
        .then((result) => {
          this.portfolioSaved(result);
        });
    });
  }

  public movePortfolio(portfolio) {
    const tempScope = this.$rootScope.$new(true);
    tempScope["oldClient"] = this.client;
    tempScope["portfolio"] = portfolio;

    this.$mdDialog
      .show({
        template:
          '<md-dialog><portfolio-transfer old-client="oldClient" portfolio="portfolio"></portfolio-transfer></md-dialog>',
        scope: tempScope,
      })
      .then((result) => {
        this.clientRepo.getClient(this.client.clientNumber).then((val) => {
          this.client = val.data;
          this.getClientPortfolioRiskProfile(this.client.id);
          this.getClientFees(this.client.clientNumber);
          this.getClientPortfolioRestrictions(this.client.id);
          this.getCrmLink();
        });
      });
  }

  public unlinkPortfolio(linkedPortfolioId: number) {
    let portfolioToRemove = this.client.portfolios.findIndex(
      (portfolio) => portfolio.portfolioId === linkedPortfolioId
    );
    this.client.portfolios.splice(portfolioToRemove, 1);
  }

  public save() {
    this.populateStrategies();
    this.clientRepo.saveClient(this.client).then((result) => {});
  }

  public cancel() {
    this.$state.go("^");
  }

  public getCrmLink() {
    if (this.client.crM_ContactId) {
      this.crmLink = `https://confident.api.crm4.dynamics.com/main.aspx?etc=2&id=${this.client.crM_ContactId}&newWindow=true&pagetype=entityrecord`;
    } else {
      this.crmLink = `https://confident.api.crm4.dynamics.com/main.aspx?etc=1&id=${this.client.crM_AccountId}&newWindow=true&pagetype=entityrecord`;
    }
  }

  public addDefaultRiskProfile = (portfolio) => {
    // if there isn't a risk profile at all then set default risk profile to be 0's.
    if (portfolio.riskProfiles.length == 0) {
      this.assetClassTypes.forEach((assetClassName) => {
        portfolio.riskProfiles.push({
          high: 0,
          low: 0,
          assetClass: {
            name: assetClassName,
          },
        });
      });
    } else if (portfolio.riskProfiles.length != this.assetClassTypes.length) {
      // get the asset class that isn't part of the list
      let assetClassesWithoutRiskProfiles = _.difference(
        this.assetClassTypes,
        portfolio.riskProfiles.map((profile) => profile.assetClass.name)
      );
      assetClassesWithoutRiskProfiles.forEach((assetClassName) => {
        portfolio.riskProfiles.push({
          high: 0,
          low: 0,
          assetClass: {
            name: assetClassName,
          },
        });
      });
    }
  };

  public savePortfolioRiskProfile = (portfolioRiskProfile) => {
    portfolioRiskProfile.isEditing = false;
    this.portfolioRepo
      .savePortfolioRiskProfile(
        portfolioRiskProfile.portfolioId,
        portfolioRiskProfile.riskProfiles
      )
      .then((res) => {
        this.getClientPortfolioRiskProfile(this.client.id);
      })
      .catch((err) => {
        this.notifyjs(`Could not save portfolio risk profile : ${err.data}`);
        this.getClientPortfolioRiskProfile(this.client.id);
      });
  };

  public cancelPortfolioRiskProfile = () => {
    this.getClientPortfolioRiskProfile(this.client.id);
  };

  public getClientFees = (clientNumber: string) => {
    this.feesRepo
      .getClientFees(clientNumber)
      .then((res) => {
        this.clientPortfolioFees = res.data as Array<any>;

        this.clientPortfolioFees.forEach((fee) => {
          fee.value = +(fee.value * 100).toFixed(4);
          fee.feeType.feeTiers.sort((a, b) => {
            return a.low > b.low ? 1 : -1;
          });
        });
      })
      .catch((err) => {
        this.notifyjs("Failed to load client fees :", err.data);
      });
  };

  convertDecToPerc = (x: number) => {
    return +(x * 100).toFixed(4);
  };

  convertToLocaleTime = (date: any) => {
    date = new Date(date);
    return moment(date).format("YYYY-MM-DD");
  };

  formatBooleanValue = (value: boolean) => {
    return value ? "Yes" : "No";
  };

  public newTradeRestriction(tradePortfolio: TradePortfolio) {
    let that = this;
    const tempScope = that.$rootScope.$new(true) as any;
    tempScope.client = that.client;
    tempScope.tradePortfolio = tradePortfolio;
    tempScope.newTradeRestriction = true;
    tempScope.securityTypeRestriction = true;
    tempScope.tradeRestriction = {};
    tempScope.securities = that.securities;

    that.$mdDialog
      .show({
        template:
          '<md-dialog flex="30"><edit-trade-restriction-modal security-Type-Restriction="securityTypeRestriction" securities="securities" trade-Restriction="tradeRestriction" trade-portfolio="tradePortfolio" new-trade-restriction="newTradeRestriction"></edit-trade-restriction-modal></md-dialog>',
        scope: tempScope,
      })
      .then((result) => {
        this.getClientPortfolioRestrictions(this.client.id).then(() => {
          this.selectedTradePortfolio = this.portfolioTradeRestrictions.find(
            (ptr) => ptr.id == this.selectedTradePortfolio.id
          );
        });
      });
  }

  public editTradeRestriction(tradeRestriction: TradeRestriction) {
    let that = this;
    const tempScope = that.$rootScope.$new(true) as any;
    tempScope.client = that.client;
    tempScope.tradePortfolio = that.selectedTradePortfolio;
    tempScope.newTradeRestriction = false;
    tempScope.securityTypeRestriction = null;
    tempScope.securities = that.securities;
    tempScope.tradeRestriction = {};
    angular.copy(tradeRestriction, tempScope.tradeRestriction);
    tempScope.securityTypeRestriction = false;

    // if (tradeRestriction.assetClass == null) {
    //   tempScope.securityTypeRestriction = true;
    // } else {
    //   tempScope.securityTypeRestriction = false;
    // }

    if (tradeRestriction.assetClass == null) {
      tempScope.securityTypeRestriction = true;
    } else {
      tempScope.securityTypeRestriction = false;
    }

    that.$mdDialog
      .show({
        template:
          '<md-dialog flex="30"><edit-trade-restriction-modal security-Type-Restriction="securityTypeRestriction" securities="securities" trade-Restriction="tradeRestriction" trade-portfolio="tradePortfolio" new-trade-restriction="newTradeRestriction"></edit-trade-restriction-modal></md-dialog>',
        scope: tempScope,
      })
      .then((result) => {
        if (result != null) {
          that.isLoading = true;
          that.getClientPortfolioRestrictions(this.client.id).then(() => {
            that.selectedTradePortfolio = this.portfolioTradeRestrictions.find(
              (ptr) => ptr.id == this.selectedTradePortfolio.id
            );
            that.selectedTradePortfolio.tradingRestrictions =
              that.selectedTradePortfolio.tradingRestrictions.filter(
                (tr) => tr.id != tradeRestriction.id
              );
            that.selectedTradePortfolio.tradingRestrictions.push(
              new TradeRestriction(result)
            );
            that.selectedTradePortfolio.tradingRestrictions.sort((a, b) =>
              a.security.name > b.security.name ? 1 : -1
            );
            that.isLoading = false;
          });
        }
      });
  }

  public setSelectedStrategy() {
    this.strategyInformation.isLocalStrategyEnabled =
      this.selectedStrategies.includes("Local");
    this.strategyInformation.isInternationalStrategyEnabled =
      this.selectedStrategies.includes("International");

    this.strategyInformation.isCombinedStrategyEnabled =
      this.strategyInformation.isLocalStrategyEnabled &&
      this.strategyInformation.isInternationalStrategyEnabled;

    if (this.selectedStrategies.includes("Combined")) {
      this.strategyInformation.isLocalStrategyEnabled = true;
      this.strategyInformation.isInternationalStrategyEnabled = true;
      this.showStrategyPanel = true;
    }
    this.showStrategyPanel = this.selectedStrategies.length !== 0;
  }
  strategiesPopulated() {
    let flag =
      this.strategyInformation.localStrategy !== null &&
      this.strategyInformation.localStrategy !== undefined &&
      this.strategyInformation.localStrategy.trim() !== "" &&
      this.strategyInformation.internationalStrategy !== null &&
      this.strategyInformation.internationalStrategy !== undefined &&
      this.strategyInformation.internationalStrategy.trim() !== "";

    return flag;
  }
  populateStrategies() {
    this.client.isLocalStrategyEnabled =
      this.strategyInformation.isLocalStrategyEnabled;

    this.client.isInternationalStrategyEnabled =
      this.strategyInformation.isInternationalStrategyEnabled;

    this.client.isCombinedStrategyEnabled =
      this.strategyInformation.isCombinedStrategyEnabled;

    this.client.localStrategy = this.strategyInformation.localStrategy
      .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
      .replace(/  /g, "&nbsp;&nbsp;");

    this.client.internationalStrategy =
      this.strategyInformation.internationalStrategy
        .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
        .replace(/  /g, "&nbsp;&nbsp;");
  }
  populatedSavedClientConfiguration() {
    if (this.client.isCombinedStrategyEnabled) {
      this.selectedStrategies.push("Combined");
    }
    if (this.client.isLocalStrategyEnabled) {
      this.selectedStrategies.push("Local");
      this.strategyInformation.isLocalStrategyEnabled = true;
      this.strategyInformation.localStrategy = this.client.localStrategy;
    }
    if (this.client.isInternationalStrategyEnabled) {
      this.selectedStrategies.push("International");
      this.strategyInformation.isInternationalStrategyEnabled = true;
      this.strategyInformation.internationalStrategy =
        this.client.internationalStrategy;
    }
    if (
      this.client.isLocalStrategyEnabled ||
      this.client.isInternationalStrategyEnabled
    ) {
      this.showStrategyPanel = true;
    }
  }
}

export const clientDetails: angular.IComponentOptions = {
  template: require("./clientdetails.html"),
  controller: ClientDetailsController,
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/clientdetails.ts